export default "__VITE_ASSET__BVvYg9x0__"